import Form from "./components/Form";
import "./App.css";

function App() {
  return (
    <div className="app">
      <div className="beer"></div>
      <Form/>
    </div>
  );
}

export default App;
